/*
  FOR FUTURE DEVS - MAPS DOCUMENTATION

  Maps package NPM page - https://www.npmjs.com/package/@react-google-maps/api
  Maps docs - https://react-google-maps-api-docs.netlify.com/
  Maps github - https://github.com/JustFly1984/react-google-maps-api/tree/master/packages/react-google-maps-api
  Google maps API docs - https://developers.google.com/maps/documentation/javascript/tutorial
*/

import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import getConfig from 'lib/next-config-compat';

// images
import mapPin from '../../../images/map-icons/map-pin.svg';
import { useTranslation } from '../../../utils/i18n';

const LocationMap = ({ lat, lng }: { lat: number; lng: number }) => {
  const { t } = useTranslation('common');
  const { publicRuntimeConfig: { googleMapsApiKey } = {} } = getConfig();

  const { isLoaded: mapLoaded, loadError } = useLoadScript({
    googleMapsApiKey: googleMapsApiKey ?? '',
  });

  const { google } = typeof window === 'undefined' ? {} : window;

  if (loadError) {
    return <div>{t('location_map.map_not_loaded')}</div>;
  }

  const position = {
    lat,
    lng,
  };

  const mapConfig = {
    options: {
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false,
      zoomControl: true,
      zoom: 14,
      zoomControlOptions: {
        position: google ? google.maps.ControlPosition.LEFT_BOTTOM : undefined,
      },
    },
    mapContainerStyle: {
      width: '100%',
      height: '100%',
    },
    center: position,
  };

  return (
    <div className="location-map" data-testid="locationMap">
      {mapLoaded && (
        <GoogleMap {...mapConfig}>
          <Marker position={position} icon={mapPin.src} />
        </GoogleMap>
      )}
    </div>
  );
};

export default LocationMap;
